import React from "react";
// import { ImageWithFallback } from "./figma/ImageWithFallback";
import { Heart, Zap, Users, Trophy } from "lucide-react";
// D:\Simplifyte\Website-www.simplifyte.com\src\assets\new-images
// import Carrers_Img from "../../assets/new-images/Careers.png";
// import Carrers_Img2 from "../../assets/new-images/Careers2.png";
import Carrers_Img from "../../assets/new-images/career-1.jpeg";
import Carrers_Img2 from "../../assets/new-images/career-2.jpeg";
import { motion, scale } from "framer-motion";

const values = [
  {
    icon: Heart,
    title: "People First",
    description:
      "We believe our team is our greatest asset. Your growth, wellbeing, and happiness are our priorities.",
  },
  {
    icon: Zap,
    title: "Move Fast",
    description:
      "Innovation waits for no one. We embrace rapid iteration, smart risks, and learning from failures.",
  },
  {
    icon: Users,
    title: "Collaborate",
    description:
      "Great ideas come from diverse perspectives. We foster an inclusive environment where every voice matters.",
  },
  {
    icon: Trophy,
    title: "Pursue Excellence",
    description:
      "Good isn't good enough. We push boundaries and raise the bar for ourselves and the industry.",
  },
];

export function OurCulture() {
  return (
    <section id="culture" className="culture-section">
      <div className="culture-container">
        <div className="culture-header">
          {/* text-[#2A9CD7] font-semibold tracking-wider text-sm px-4 py-2 rounded-full border border-blue-200 */}
          <span className=" carrers_culture_badge">OUR CULTURE</span>
          <h2 className="carrers_Innovation_Meets">
            Where Innovation Meets Humanity
          </h2>
          <p className="carrers_Innovation_para">
            At Simplifyte, we're not just building products—we're creating an
            environment where exceptional people do their best work.
          </p>
        </div>

        {/* Image grid */}
        <div className="culture-images">
          <motion.div
            className="culture-image"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{
              scale: 1.03,
              y: -1,
              boxShadow: "0 8px 2px rgba(0,0,0,0.2)",
            }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <img
              // src="https://images.unsplash.com/photo-1739298061707-cefee19941b7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx0ZWFtJTIwY29sbGFib3JhdGlvbiUyMG1lZXRpbmd8ZW58MXx8fHwxNzYzNjkxMzc3fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
              src={Carrers_Img}
              alt="Team collaboration"
              className="image"
            />
            <div className="image-overlay"></div>
          </motion.div>

          <motion.div
            className="culture-image"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{
              scale: 1.03,
              y: -1,
              boxShadow: "0 8px 2px rgba(0,0,0,0.2)",
            }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
          >
            <img
              // src="https://images.unsplash.com/photo-1630283017802-785b7aff9aac?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjB3b3Jrc3BhY2V8ZW58MXx8fHwxNzYzNzI2OTQxfDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
              src={Carrers_Img2}
              alt="Modern workspace"
              className="image"
            />
            <div className="image-overlay"></div>
          </motion.div>
        </div>

        {/* Values grid */}
        <div className="culture-values">
          {values.map((value) => (
            <div key={value.title} className="value-card">
              <div className="value-bg"></div>
              <value.icon className="value-icon " />
              <h4 className="card_title_class">{value.title}</h4>
              <p className="card_para_class">{value.description}</p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .culture-section {
          background: #fff;
          overflow: hidden;
          padding: 64px 0px;
        }
        .culture-container {
          max-width: 1280px;
          margin: 0 auto;
        }
        .culture-header {
          text-align: center;
          margin-bottom: 5rem;
        }
        .culture-label {
          display: inline-block;
          padding: 0.5rem 1rem;
          margin-bottom: 1.5rem;
          font-size: 0.875rem;
          letter-spacing: 0.1em;
          color: #2A9CD7;
          border: 1px solid rgba(42, 156, 215, 0.2);
          border-radius: 999px;
        }
        .culture-title {
          color: #093A5B;
          font-size: 2.5rem;
          margin-bottom: 1rem;
        }
        .culture-subtitle {
          color: #4B5563;
          font-size: 1.125rem;
          max-width: 700px;
          margin: 0 auto;
        }
        .culture-images {
          display: grid;
          grid-template-columns: 1fr;
          gap: 2rem;
          margin-bottom: 5rem;
        }
        .culture-image {
          position: relative;
          height: 400px;
          border-radius: 1.5rem;
          overflow: hidden;
          box-shadow: 0 10px 20px rgba(0,0,0,0.15);
        }
        .image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .image-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(255,255,255,0.3), transparent);
            transition: background 0.3s ease;
        }
        .culture-image:hover .image-overlay {
       background: linear-gradient(to top, rgba(255,255,255,0), transparent);
}
       .culture-image:hover {
  transform: scale(1.03);
}
        .culture-values {
          display: grid;
          grid-template-columns: 1fr;
          gap: 2rem;
        }
        .value-card {
          position: relative;
          padding: 2rem;
          background: #F5F7FB;
          border-radius: 1rem;
          transition: all 0.3s ease;
        }
        .value-card:hover {
          background: #fff;
          box-shadow: 0 10px 20px rgba(0,0,0,0.15);
        }
          @media(max-width:640px){
            .value-card {
            padding:1rem
            }
          }
        .value-bg {
          position: absolute;
          top: 2rem;
          left: 2rem;
          width: 48px;
          height: 48px;
          background: rgba(42,156,215,0.1);
          border-radius: 999px;
          transition: transform 3s ease;
        }
          @media(max-width:640px){
          .value-bg {
          top: 1rem;
          left: 1rem;
          }
          }
        .value-card:hover .value-bg {
          transform: scale(1.1);
          duration: 3s;
        }
        .value-icon {
          position: relative;
          z-index: 10;
          width: 28px;
          height: 28px;
          color: #2A9CD7;
          margin-bottom: 8px;
          margin-left: 10px;
          margin-top: 10px;
        }

        /* Responsive */
        @media (min-width: 640px) {
          .culture-images { grid-template-columns: repeat(2,1fr); }
          .culture-values { grid-template-columns: repeat(2,1fr); }
        }
        @media (min-width: 1024px) {
          .culture-values { grid-template-columns: repeat(4,1fr); }
          .culture-title { font-size: 3rem; }
          .culture-subtitle { font-size: 1.125rem; }
        }
      `}</style>
    </section>
  );
}
